import { DatePicker } from "antd";
import DropDown from "../../UIComponents/CustomDropDown/SrDropDown";
import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { srReportGeneration } from "../../Redux/actions/Sr/Sr";
import Button from "../../UIComponents/Button/Button";
import "./Sr.css";
// import SrtTabs from "./SrtTabs";
import { toast } from "../../UIComponents/Toast";
import SrTabs from "./SrTabs";

const Sr = () => {
  const { RangePicker } = DatePicker;
  const dispatch = useDispatch();
  const styleListData = useSelector((state) => state?.Srf?.srfFilterData);
  console.log("inset", styleListData);
  const [brandOptions, setBrandOptions] = useState([]);
  const [brandId, setBrandId] = useState();
  const [selectedRange, setSelectedRange] = useState([]);
  const [onSubmitClearDate, setOnSubmitClearDate] = useState([]);
  const [seasonFilter, setSeasonFilter] = useState();
  const [brand, setBrand] = useState();
  const [seasonOptions, setSeasonOptions] = useState([]);

  const option = [
    {
      value: "All",
      label: "All",
    },
    {
      value: "Aims",
      label: "Aims",
    },
    {
      value: "Ayesha",
      label: "Ayesha",
    },
    {
      value: "Beacon",
      label: "Beacon",
    },
    {
      value: "Bonroy",
      label: "Bonroy",
    },
    {
      value: "Crescent pk",
      label: "Crescent pk",
    },
    {
      value: "Denoho",
      label: "Denoho",
    },
    {
      value: "Dynamic",
      label: "Dynamic",
    },
    {
      value: "Enva",
      label: "Enva",
    },
    {
      value: "Evergreen",
      label: "Evergreen",
    },
    {
      value: "Everight",
      label: "Everight",
    },
    {
      value: "Four seasons",
      label: "Four seasons",
    },
    {
      value: "Ideal",
      label: "Ideal",
    },
    {
      value: "Infiiloom",
      label: "Infiiloom",
    },
    {
      value: "Interloop",
      label: "Interloop",
    },
    {
      value: "Kahatex",
      label: "Kahatex",
    },
    {
      value: "Kamal",
      label: "Kamal",
    },
    {
      value: "Keystone",
      label: "Keystone",
    },
    {
      value: "MSL",
      label: "MSL",
    },
    {
      value: "Northeast",
      label: "Northeast",
    },
    {
      value: "Ou wei",
      label: "Ou wei",
    },
    {
      value: "Premium",
      label: "Premium",
    },
    {
      value: "Rong xing",
      label: "Rong xing",
    },
    {
      value: "Royal",
      label: "Royal",
    },
    {
      value: "Royce",
      label: "Royce",
    },
    {
      value: "RRK",
      label: "RRK",
    },
    {
      value: "Salus",
      label: "Salus",
    },
    {
      value: "Slane",
      label: "Slane",
    },
    {
      value: "Spry",
      label: "Spry",
    },
    {
      value: "Super",
      label: "Super",
    },
    {
      value: "Talent",
      label: "Talent",
    },
    {
      value: "Talent Cambodia",
      label: "Talent Cambodia",
    },
    {
      value: "Tauseef",
      label: "Tauseef",
    },
    {
      value: "Textilfort",
      label: "Textilfort",
    },
    {
      value: "Walt",
      label: "Walt",
    },
    {
      value: "Xuren",
      label: "Xuren",
    },
    {
      value: "Yiheng",
      label: "Yiheng",
    },
    {
      value: "Shahzad Textile",
      label: "Shahzad Textile",
    },
    {
      value: "Close Knit",
      label: "Close Knit",
    },
    {
      value: "Superhouse",
      label: "Superhouse",
    },
    {
      value: "Mustaqim",
      label: "Mustaqim",
    }
  ];
  const sortedOptions = [...option].sort((a, b) =>
    a.label.localeCompare(b.label)
  );
  const handleChange = (value) => {
    setBrandId(value);
  };
  const onDateChange = (dates, dateString) => {
    setSelectedRange(dateString);
    setOnSubmitClearDate(dates);
  };

  const onSeasonChange = (values) => {
    if (!values || values.length === 0) {
      setSeasonFilter(undefined);
      return;
    }

    // If Select All clicked
    if (values.includes("ALL")) {
      const allSeasons = seasonOptions
        .filter((item) => item.value !== "ALL")
        .map((item) => item.value);

      setSeasonFilter(allSeasons);
    } else {
      setSeasonFilter(values);
    }
  };

  const handleBrandChange = (value) => {
    if (!value || value === "ALL") {
      setBrand("All");   // No filter
    } else {
      setBrand(value);
    }
  };
  const onSubmitClick = () => {
    if (!seasonFilter) {
      toast.error("!Please select season");
    } else if (!brandId) {
      toast.error("!Please select Vendor");
    }
    else {
      dispatch(
        srReportGeneration(
          brandId,
          selectedRange[0] ? selectedRange[0] : "",
          selectedRange[1] ? selectedRange[1] : "",
          seasonFilter,
          brand
        )
      );
      setBrandId();
      setSeasonFilter();
      setSelectedRange([]);
      setOnSubmitClearDate([]);
      setBrand();
    }
  };
  const handleKeyDown = (event) => {
    // console.log("keyevent", event);
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    // Regular expression to match only numeric characters and allowed keys
    const allowedKeys = [
      "Tab",
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
    ];
    const numericRegex = /^[0-9]*$/;

    if (!numericRegex.test(keyValue) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  };
  useEffect(() => {
    if (styleListData && Array?.isArray(styleListData)) {
      const uniqueBrands = [
        ...new Set(
          styleListData
            .map((item) => item?.brand?.trim())
            .filter(Boolean)
        ),
      ];

      const formattedBrands = [
        { value: "ALL", label: "All" },
        ...uniqueBrands.map((brand) => ({
          value: brand,
          label: brand,
        })),
      ];

      setBrandOptions(formattedBrands);
      console.log("srformattedbrnads", formattedBrands);
      const uniqueSeasons = [
        ...new Set(
          styleListData
            .map((item) => item?.season?.trim().toUpperCase())
            .filter(Boolean)
        ),
      ];
      const formattedSeasons = [
        { value: "ALL", label: "Select All" },
        ...uniqueSeasons.map((season) => ({
          value: season,
          label: season,
        })),
      ];

      setSeasonOptions(formattedSeasons);
    }
  }, [styleListData]);
  const srtScrollPosition = localStorage.getItem("srtAutoScroll");
  const srtApiListingData = localStorage.getItem("srApiData");

  const containerRef = useRef(null);

  const handleScroll = () => {
    if (containerRef.current) {
      const scrollTop = containerRef?.current?.scrollTop;
      localStorage.setItem("srtAutoScroll", scrollTop);
    }
  };

  const handleScrollButton = () => {
    if (srtScrollPosition) {
      window.scrollTo({
        top: containerRef?.current?.offsetTop,
      });
      containerRef?.current?.scrollTo({
        top: srtScrollPosition,
      });
    }
  };

  useLayoutEffect(() => {
    handleScrollButton();
  }, [srtApiListingData]);

  // useEffect(() => {
  //   console.log("scroll position of localstorage", srtScrollPosition);
  //   handleScrollButton();
  // }, [srtApiListingData]);

  return (
    <div
      ref={containerRef}
      onScroll={handleScroll}
      className="srt-main-wrapper"
    >
      <div className="report-generation-top-wrapper">
        <p className="report-generation-label">Report Generation</p>
        <div className="report-generation-top-container">
          <div className="brand-drop-down">
            <DropDown
              allowClear
              placeholder={"Brand"}
              options={brandOptions}
              // options={brands}
              value={brand}
              onChange={handleBrandChange}
            />
          </div>
          <div className="dickies-drop-down-one">
            <DropDown
              mode="multiple"
              allowClear
              onChange={onSeasonChange}
              placeholder={"Season"}
              options={seasonOptions}
              // options={seasons}
              value={seasonFilter}
              enableSelectAll
            />
          </div>
          <div className="srt-first-drop-down">
            <DropDown
              allowClear
              placeholder={"Vendor"}
              options={sortedOptions}
              value={brandId}
              onChange={handleChange}
            />
          </div>
          <div className="range-picker-container">
            <RangePicker
              onKeyDown={handleKeyDown}
              allowClear={false}
              format={"MM/DD/YYYY"}
              onChange={onDateChange}
              value={onSubmitClearDate}
            />
          </div>
          <Button
            onClick={onSubmitClick}
            className="submit-buttom"
            children={"SUBMIT"}
          />
        </div>
      </div>
      <SrTabs containerRef={containerRef} />
    </div>
  );
};

export default Sr;
